import React from 'react';

import RIACLogo from '@riac/core/assets/riac_logo_transparent_black_full.png?h=95';
import RIACGoldLogo from '@riac/core/assets/riac_logo_transparent_gold_full.png?h=95';
import { cn, Typography } from '@riac/design-system';

export type EmptyStateProps = React.PropsWithChildren<{
  className?: string | string[],
  title: string,
  description: string,
}>;

export const EmptyState = (props: EmptyStateProps): JSX.Element => {
  return (
    <div className = {cn('flex flex-col items-center gap-5 max-w-[386px] m-auto', props.className)}>
      <div className='flex flex-col gap-8 items-center'>
        <div>
          <img src={RIACGoldLogo} alt='Rock Island Auction Company' className='h-[95px] hidden dark:block'/>
          <img src={RIACLogo} alt='Rock Island Auction Company' className='h-[95px] block dark:hidden'/>
        </div>
        <div className = 'flex flex-col items-center gap-2 text-center'>
          <Typography align = 'center' weight = 'bold'>{props.title}</Typography>
          <Typography align = 'center'>{props.description}</Typography>
        </div>
      </div>
      {props.children}
    </div>
  );
};
